/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { compact, Compactable } from '../guards/compact';
import { hasOneElement } from '../iterators/hasOneElement';
import { isEmpty } from '../guards/isEmpty';

import { createVisitor, VisitorsMap } from './createVisitor';

export const itemsCountVisitor = <VALUE, ACCEPT>(
   data: Compactable<VALUE>[] | null | undefined,
   visitors: VisitorsMap<
      {
         visitEmpty: void;
         visitSingle: VALUE;
         visitMultiple: Array<VALUE>;
      },
      ACCEPT
   >
) => {
   return createVisitor<
      Compactable<VALUE>[] | null | undefined,
      {
         visitEmpty: void;
         visitSingle: VALUE;
         visitMultiple: Array<VALUE>;
      }
   >((data, visitors) => {
      const compactedData = isEmpty(data) ? data : compact(data);
      if (isEmpty(compactedData)) {
         return visitors.visitEmpty?.();
      }

      if (hasOneElement(compactedData)) {
         const [single] = compactedData;
         return visitors.visitSingle?.(single as Exclude<VALUE, undefined>);
      }

      return visitors.visitMultiple?.(compactedData);
   })(data, visitors);
};
